<template>
    <GenericSelector
        :value="value"
        @input="val => $emit('input', value)"
        :options="options"
        :showOptions="showOptions"
        :loading="loading"
        :displayCb="student => !loading ? student.user.displayname : ''"
    >
        <template v-slot:selectedHeader>
            <div class="list-group border-radius-2 no-border mb-2">
                <div class="list-group-item text-sm font-weight-bold">{{ $t('students') }}</div>
            </div>
        </template>

        <template v-slot:unselectedHeader>
            <div class="clearfix my-2">
                <button 
                    type="button" 
                    @click="showOptions = !showOptions"
                    class="btn float-right" 
                    :class="showOptions ? 'btn-secondary' : 'btn-primary'"
                >
                    <b-icon v-if="!showOptions" icon="plus" class="h6 mb-0 mr-1"/>{{ showOptions ? $t('done') : $t('edit') }}
                </button>
            </div>
        </template>
    </GenericSelector>
</template>

<script>
import GenericSelector from "src/components/Inputs/GenericSelector.vue"

export default {
    components: {
        GenericSelector,
    },
    props: {
        value: {
            type: Array,
            default: () => [],
        },
        groupTypeId: {
            type: [Number, String],
            required: true,
        },
        groupId: {
            type: [Number, String],
            required: true,
        },
    },
    mounted() {
        this.getStudents().then(() => {
            // This component fetches students with their user attached. 
            // In case the v-bound students do not, let's attach them.
            const studentsById = {}
            this.students.forEach(student => { studentsById[student.id] = student })
            this.value.forEach(student => student.user = studentsById[student.id].user)
            this.loading = false
        })
    },
    data() {
        return {
            loading: true,
            students: [],
            showOptions: false,
        }
    },
    methods: {
        getStudents() {
            return this.$cfetch(`${this.$settings.APIBaseURL}/grouptypes/yeargroups/students/available`, {
                method: 'GET',
                data: {
                    grouptype_id: this.groupTypeId,
                    group_id: this.groupId,
                }
            }).then(res => {
                if (res.status !== 'SUCCESS') throw new Error()

                this.students = res.results
            }).catch(err => {
                console.error(err)
                this.$log.error.call(this, err)
                this.$store.commit('openDialog', {
                    title: this.$t('something-went-wrong'),
                    content: this.$t('error-fetching-students'),
                })
            })
        },
    },
    computed: {
        options() {
            return this.students
        }
    }
}
</script>